import { Directive, ElementRef, AfterViewInit, inject } from "@angular/core";

@Directive({
  standalone: true,
  selector: "[lorenAutofocus]",
})
export class LorenAutofocusDirective implements AfterViewInit {
  private host = inject(ElementRef);


  ngAfterViewInit() {
    this.host.nativeElement.focus();
    this.host.nativeElement.scrollIntoView();
  }
}
